export default {
    find:   { method: 'get',    url: 'teacher_positions' },
    create: { method: 'post',   url: 'teacher_positions'},
    update: { method: 'put',    url: 'teacher_positions/{id}'},
    delete: { method: 'delete', url: 'teacher_positions/{id}'}
}